import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';

import { MessageService } from 'primeng/components/common/messageservice';

import { BaseService } from '../base/util/base.service';
import {
  criarTokenGto,
  dadosCadastraisBeneficiario,
  enviarTokenGto,
  listaJustificativas,
  salvarJustificativa,
  salvarTokenGto,
  validarTokenGto,
} from '../base/util/url-util';
import { SalvaTokenGto } from '../base/vo/salva-token-gto';
import { CriarTokenGtoRequest, EnviarTokenGtoRequest, ValidarTokenGtoRequest } from '../base/vo/tokenGto';


@Injectable()
export class GtoTokenService extends BaseService {

  public canOpenModalTokenOnFinalizar = new BehaviorSubject<boolean>(false);
  public reloadDetalhaGTO = new BehaviorSubject<boolean>(false);

  private _canOpenModalTokenOnFinalizar: Observable<boolean> = this.canOpenModalTokenOnFinalizar.asObservable();
  private _reloadDetalhaGTO: Observable<boolean> = this.reloadDetalhaGTO.asObservable();

  constructor(public http: HttpClient, public messageService: MessageService) {
    super(http, messageService);
  }

  public getListaJustificativas() {
    return this.get(listaJustificativas());
  }

  public salvarJustificativa(salvaTokenGto: SalvaTokenGto) {
    return this.post(salvarJustificativa(), salvaTokenGto);
  }

  public salvarTokenGto(salvaTokenGto: SalvaTokenGto) {
    return this.post(salvarTokenGto(), salvaTokenGto);
  }

  public criarTokenGto(criarTokenGtoRequest: CriarTokenGtoRequest) {
    return this.post(criarTokenGto(), criarTokenGtoRequest);
  }

  public enviarTokenGto(enviarTokenGtoRequest: EnviarTokenGtoRequest) {
    return this.post(enviarTokenGto(), enviarTokenGtoRequest);
  }

  public validarTokenGto(validarTokenGtoRequest: ValidarTokenGtoRequest) {
    return this.post(validarTokenGto(), validarTokenGtoRequest);
  }

  public getDadosCadastraisBeneficiario(codigoBeneficiario: String) {
    return this.get(dadosCadastraisBeneficiario(codigoBeneficiario));
  }

  public formatarTokenMensagem(tokenMensagem: string, nomeBeneficiario: string, numeroGto: string) {
    tokenMensagem = tokenMensagem.replace('[nomeBeneficiario]', nomeBeneficiario);
    tokenMensagem = tokenMensagem.replace('[numeroGuia]', numeroGto);

    return tokenMensagem;
  }

  getCanOpenModalTokenOnFinalizar() {
    return this._canOpenModalTokenOnFinalizar;
  }

  setCanOpenModalTokenOnFinalizar(openModal: boolean) {
    this.canOpenModalTokenOnFinalizar.next(openModal);
  }

  getReloadDetalhaGTO() {
    return this._reloadDetalhaGTO;
  }

  setReloadDetalhaGTO(reload: boolean) {
    this.reloadDetalhaGTO.next(reload);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/gto-token/gto-token.service.ts